
let _ = require('../_.js');
let $ = jQuery;


_.auctionui_replace_custom_nouns = function () {
    $(".ac_noun_item_singular_upper").text(_.property_noun_item_singular().toUpperCase());
    $(".ac_noun_item_plural_upper").text(_.property_noun_item_plural().toUpperCase());
    $(".ac_noun_item_singular").text(_.property_noun_item_singular());
    $(".ac_noun_item_plural").text(_.property_noun_item_plural());
    $(".ac_noun_item_plural_ucwords").text(_.property_noun_item_plural_ucwords());
    $(".ac_noun_item_singular_ucwords").text(_.property_noun_item_singular_ucwords());
    $(".ac_noun_unit_plural_ucwords").text(_.property_noun_item_plural_ucwords());
}

// Whole farm auctions: .ac_noun_whole_farm / .ac_noun_whole_farm_upper spans show the whole farm lot's
// title. Filled at init and again whenever the auction's items change (a rename arrives in realtime).
_.auctionui_replace_whole_farm_nouns = async function () {
    let title = await _.AuctionUI_Data.whole_farm_title();
    $(".ac_noun_whole_farm").text(title);
    $(".ac_noun_whole_farm_upper").text(title.toUpperCase());
}